//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scrolingGallery } from '~/utils/utils';

  export default {
    props: {
      progresses: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      eventsListenersAchieve() {
        return {
          ...this.$listeners,
          ...scrolingGallery(this, 'profileAchievements')
        }
      },
      complitedAchievements() {
        return this.progresses.filter(elem => elem.dateAccepted)
      },
      visibleAchievements() {
        const arr = [...this.progresses]
        const cortedArr = arr.sort((a, b) => {
          const resA = a.dateAccepted
          const resB = b.dateAccepted
          return (resA === resB) ? 0 : resA ? -1 : 1
        })
        if (cortedArr.length > 5) {
          return cortedArr.splice(0, 6)
        }
        return arr
      }
    },
    methods: {
      pictureUrl (url) {
        return this.$absoluteImageUrl(url)
      }
    }
  }
